/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ companyName: NonNullable<unknown> }} Welcome_Landing_HeadingInputs */

const en_welcome_landing_heading = /** @type {(inputs: Welcome_Landing_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Welcome to ${i?.companyName}'s Client Experience Platform`)
};

/**
* | output |
* | --- |
* | "Welcome to {companyName}'s Client Experience Platform" |
*
* @param {Welcome_Landing_HeadingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const welcome_landing_heading = /** @type {((inputs: Welcome_Landing_HeadingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Welcome_Landing_HeadingInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_welcome_landing_heading(inputs)
});